import { createGlobalStyle } from 'styled-components';
import { maxMobile } from '../Utils/utilsStyle';

const GeneralStylePeopleDashboard = createGlobalStyle`
  .Grid-width-row {
    &.person-i-follow-negative {
      @media all and (max-width: ${maxMobile}) {
        margin-top: -20px !important;
      }
    }
  }
`;

export default GeneralStylePeopleDashboard;
